export const WORK_TYPES = [
  { value: 'REGULAR', label: 'Regular' },
  { value: 'OVERTIME', label: 'Overtime' },
  { value: 'SECOND_SHIFT', label: 'Second Shift' },
  { value: 'THIRD_SHIFT', label: 'Third Shift' }
]
